import {
  HookOptions,
  useStatsQuery,
} from "../extensions/sw/modules/stats/hooks";
import { StatsQuery } from "../extensions/sw/modules/stats/types";
import { GlobalStatsSelection } from "../types/stats";
import { WorkerQueryOptions } from "../libs/workers/types";

export function useMatchCount(
  data: {
    selection?: GlobalStatsSelection;
    filters?: Record<string, any>;
    opts?: WorkerQueryOptions;
  },
  opts?: HookOptions<typeof StatsQuery.MATCH_COUNT>
) {
  return useStatsQuery(
    {
      type: StatsQuery.MATCH_COUNT,
      data: {
        cityEscapeIds: data.selection?.cityEscapeIds,
        productIds: data.selection?.productIds,
        filters: data.filters,
      },
      opts: { ...opts, traceKey: data.opts?.traceKey ?? "useMatchCount" },
    },
    opts
  );
}

export function useMatchPlayRate(
  data: {
    selection?: GlobalStatsSelection;
    filters?: Record<string, any>;
    opts?: WorkerQueryOptions;
  },
  opts?: HookOptions<typeof StatsQuery.MATCH_PLAY_RATE>
) {
  return useStatsQuery(
    {
      type: StatsQuery.MATCH_PLAY_RATE,
      data: {
        cityEscapeIds: data.selection?.cityEscapeIds,
        productIds: data.selection?.productIds,
        filters: data.filters,
      },
      opts: { ...data.opts, traceKey: data.opts?.traceKey ?? "useMatchPlayRate" },
    },
    opts
  );
}

export function useMatchCompletionRate(
  data: {
    selection?: GlobalStatsSelection;
    filters?: Record<string, any>;
    opts?: WorkerQueryOptions;
  },
  opts?: HookOptions<typeof StatsQuery.MATCH_COMPLETION_RATE>
) {
  return useStatsQuery(
    {
      type: StatsQuery.MATCH_COMPLETION_RATE,
      data: {
        cityEscapeIds: data.selection?.cityEscapeIds,
        productIds: data.selection?.productIds,
        filters: data.filters,
      },
      opts: { ...data.opts, traceKey: data.opts?.traceKey ?? "useMatchCompletionRate" },
    },
    opts
  );
}

export function useMatchAvgDurationFromPurchaseToEnd(
  data: {
    selection?: GlobalStatsSelection;
    filters?: Record<string, any>;
    opts?: WorkerQueryOptions;
  },
  opts?: HookOptions<typeof StatsQuery.MATCH_AVG_DURATION_FROM_PURCHASE_TO_COMPLETION>
) {
  return useStatsQuery(
    {
      type: StatsQuery.MATCH_AVG_DURATION_FROM_PURCHASE_TO_COMPLETION,
      data: {
        cityEscapeIds: data.selection?.cityEscapeIds,
        productIds: data.selection?.productIds,
        filters: data.filters,
      },
      opts: {
        ...data.opts,
        traceKey: data.opts?.traceKey ?? "useMatchAvgDurationFromPurchaseToEnd",
      },
    },
    opts
  );
}

export function useMatchAvgDurationFromCreationTocompletion(
  data: {
    selection?: GlobalStatsSelection;
    filters?: Record<string, any>;
    opts?: WorkerQueryOptions;
  },
  opts?: HookOptions<typeof StatsQuery.MATCH_AVG_DURATION_FROM_CREATION_TO_COMPLETION>
) {
  return useStatsQuery(
    {
      type: StatsQuery.MATCH_AVG_DURATION_FROM_CREATION_TO_COMPLETION,
      data: {
        cityEscapeIds: data.selection?.cityEscapeIds,
        productIds: data.selection?.productIds,
        filters: data.filters,
      },
      opts: {
        ...data.opts,
        traceKey: data.opts?.traceKey ?? "useMatchAvgDurationFromCreationTocompletion",
      },
    },
    opts
  );
}

export function useMatchAvgDurationFromFirstToLastEnigma(
  data: {
    selection?: GlobalStatsSelection;
    filters?: Record<string, any>;
    opts?: WorkerQueryOptions;
  },
  opts?: HookOptions<typeof StatsQuery.MATCH_AVG_DURATION_FROM_FIRST_TO_LAST_ENIGMA>
) {
  return useStatsQuery(
    {
      type: StatsQuery.MATCH_AVG_DURATION_FROM_FIRST_TO_LAST_ENIGMA,
      data: {
        cityEscapeIds: data.selection?.cityEscapeIds,
        productIds: data.selection?.productIds,
        filters: data.filters,
      },
      opts: {
        ...data.opts,
        traceKey: data.opts?.traceKey ?? "useMatchAvgDurationFromFirstToLastEnigma",
      },
    },
    opts
  );
}

export function useMatchOpenRate(
  data: {
    selection?: GlobalStatsSelection;
    filters?: Record<string, any>;
    opts?: WorkerQueryOptions;
  },
  opts?: HookOptions<typeof StatsQuery.MATCH_OPEN_RATE>
) {
  return useStatsQuery(
    {
      type: StatsQuery.MATCH_OPEN_RATE,
      data: {
        cityEscapeIds: data.selection?.cityEscapeIds,
        productIds: data.selection?.productIds,
        filters: data.filters,
      },
      opts: {
        ...data.opts,
        traceKey: data.opts?.traceKey ?? "useMatchOpenRate",
      },
    },
    opts
  );
}

export type SceneStatsSummary = {
  playRate: number;
  avgDuration: number;
  avgTimeFromStart: number;
};

export function useSceneStatsSummary(
  cityEscapeId: string | null,
  sceneId: string,
  filters?: Record<string, any>,
  opts?: WorkerQueryOptions
) {
  return useStatsQuery({
    type: StatsQuery.SCENE_STATS_SUMMARY,
    data: { cityEscapeId, sceneId, filters },
    opts: {
      ...opts,
      traceKey: opts?.traceKey ?? "useSceneStatsSummary",
    },
  });
}

export function useCityEscapeAvgRating(
  cityEscapeIds?: string | string[] | null,
  filters?: Record<string, any>,
  opts?: WorkerQueryOptions
) {
  return useStatsQuery({
    type: StatsQuery.CITY_ESCAPE_AVG_RATING,
    data: { cityEscapeIds, filters },
    opts: {
      ...opts,
      traceKey: opts?.traceKey ?? "useCityEscapeAvgRating",
    },
  });
}
